// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Formality = require("../../../vendor/re-formality/Formality.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ReasonPromise = require("../../../reason/ReasonPromise.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let AttachmentFormUtils = require("../../common/attachments/AttachmentFormUtils.bs.js");
let Formality__Debouncer = require("../../../vendor/re-formality/Formality__Debouncer.bs.js");
let PropertyFieldConfigs = require("./PropertyFieldConfigs.bs.js");
let Formality__ReactUpdate = require("../../../vendor/re-formality/Formality__ReactUpdate.bs.js");

let validators_files = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let files = param.files;
    let err = AttachmentFormUtils.validateAttachments(files);
    if (err.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: Stdlib_Array.filterMap(files, file => {
          let match = file.state;
          if (match.TAG !== "Success") {
            return;
          }
          let match$1 = match._0;
          return {
            contentType: match$1.contentType,
            fileName: match$1.fileName,
            id: match$1.id,
            key: match$1.key
          };
        })
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          NAME: "AttachmentsError",
          VAL: err._0
        }
      };
    }
  }
};

let validators_images = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let images = param.images;
    let err = AttachmentFormUtils.validateAttachments(images);
    if (err.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: Stdlib_Array.filterMap(images, image => {
          let match = image.state;
          if (match.TAG !== "Success") {
            return;
          }
          let match$1 = match._0;
          return {
            contentType: match$1.contentType,
            fileName: match$1.fileName,
            id: match$1.id,
            key: match$1.key
          };
        })
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          NAME: "AttachmentsError",
          VAL: err._0
        }
      };
    }
  }
};

let validators_emailAddress = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => PropertyFieldConfigs.ClientEmailAddress.validate(param.emailAddress)
};

let validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let firstName = param.firstName;
    if (firstName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: firstName
      };
    }
  }
};

let validators_description = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let description = param.description;
    switch (param.privacy) {
      case "Normal" :
      case "HideMyName" :
        if (description !== undefined) {
          return {
            TAG: "Ok",
            _0: description
          };
        } else {
          return {
            TAG: "Error",
            _0: "IsRequired"
          };
        }
      case "HideProperty" :
        return {
          TAG: "Ok",
          _0: undefined
        };
    }
  }
};

let validators_numberOfUnits = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let propertyType = param.propertyType;
    if (propertyType !== undefined) {
      return PropertyFieldConfigs.ForSalePropertyAttributes.validateNumberOfUnits(propertyType, param.numberOfUnits);
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
};

let validators_lotSize = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let propertyType = param.propertyType;
    if (propertyType !== undefined) {
      return PropertyFieldConfigs.ForSalePropertyAttributes.validateLotSize(propertyType, param.lotSize);
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
};

let validators_livingArea = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let propertyType = param.propertyType;
    if (propertyType !== undefined) {
      return PropertyFieldConfigs.ForSalePropertyAttributes.validateLivingArea(propertyType, param.livingArea);
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
};

let validators_halfBaths = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let propertyType = param.propertyType;
    if (propertyType !== undefined) {
      return PropertyFieldConfigs.ForSalePropertyAttributes.validateHalfBaths(propertyType, param.halfBaths);
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
};

let validators_baths = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let propertyType = param.propertyType;
    if (propertyType !== undefined) {
      return PropertyFieldConfigs.ForSalePropertyAttributes.validateBaths(propertyType, param.baths);
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
};

let validators_beds = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let propertyType = param.propertyType;
    if (propertyType !== undefined) {
      return PropertyFieldConfigs.ForSalePropertyAttributes.validateBeds(propertyType, param.beds);
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
};

let validators_propertyType = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let propertyType = param.propertyType;
    if (propertyType !== undefined) {
      return {
        TAG: "Ok",
        _0: propertyType
      };
    } else {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    }
  }
};

let validators_maxPrice = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => PropertyFieldConfigs.ForSalePropertyPrice.validateMaxPrice(param.priceType, param.minPrice, param.maxPrice)
};

let validators_minPrice = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => PropertyFieldConfigs.ForSalePropertyPrice.validateMinPrice(param.priceType, param.minPrice)
};

let validators_price = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => PropertyFieldConfigs.ForSalePropertyPrice.validatePrice(param.priceType, param.price)
};

let validators_location = {
  strategy: "OnFirstChange",
  validate: (param, param$1) => PropertyFieldConfigs.PropertyLocation.validate(param.location),
  validateAsync: Formality__Debouncer.make(700, param => {
    let dispatch = param[2];
    let value = param[0];
    let validate = (location, param) => Utils__Promise.toJsPromise(ReasonPromise.map(ReasonPromise.map(param.geocodingQueryFn(location.address, location.area.id), v => {
      if (v.TAG !== "Ok") {
        return {
          TAG: "Error",
          _0: {
            NAME: "GeocodingError",
            VAL: "UnableToGeocode"
          }
        };
      }
      let e = v._0;
      if (e.NAME === "PropertyAddressValidated") {
        return {
          TAG: "Ok",
          _0: location
        };
      } else {
        return {
          TAG: "Error",
          _0: e
        };
      }
    }), e => ({
      TAG: "Ok",
      _0: e
    })));
    Formality.Async.validateAsyncWithMetadata(value, param[1], validate, res => dispatch({
      TAG: "ApplyAsyncResultForLocationField",
      _0: value,
      _1: res
    }));
  }),
  eq: (a, b) => a === b
};

let validators_area = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let area = param.area;
    if (area !== undefined) {
      return {
        TAG: "Ok",
        _0: area
      };
    } else {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    }
  }
};

let validators_address = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let address = param.address;
    if (address === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: address
      };
    }
  }
};

let validators = {
  files: validators_files,
  images: validators_images,
  emailAddress: validators_emailAddress,
  lastName: undefined,
  firstName: validators_firstName,
  description: validators_description,
  privacy: undefined,
  parkingDetails: undefined,
  parkingSpaces: undefined,
  numberOfUnits: validators_numberOfUnits,
  lotSize: validators_lotSize,
  livingArea: validators_livingArea,
  halfBaths: validators_halfBaths,
  baths: validators_baths,
  beds: validators_beds,
  propertyType: validators_propertyType,
  maxPrice: validators_maxPrice,
  minPrice: validators_minPrice,
  price: validators_price,
  priceType: undefined,
  location: validators_location,
  area: validators_area,
  address: validators_address
};

function initialFieldsStatuses(input) {
  return {
    files: "Pristine",
    images: "Pristine",
    emailAddress: "Pristine",
    lastName: "Pristine",
    firstName: "Pristine",
    description: "Pristine",
    privacy: "Pristine",
    parkingDetails: "Pristine",
    parkingSpaces: "Pristine",
    numberOfUnits: "Pristine",
    lotSize: "Pristine",
    livingArea: "Pristine",
    halfBaths: "Pristine",
    baths: "Pristine",
    beds: "Pristine",
    propertyType: "Pristine",
    maxPrice: "Pristine",
    minPrice: "Pristine",
    price: "Pristine",
    priceType: "Pristine",
    location: "Pristine",
    area: "Pristine",
    address: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  let match = fieldsStatuses.files;
  let tmp;
  tmp = typeof match !== "object" ? validators.files.validate(input, metadata) : match._0;
  let match$1 = fieldsStatuses.images;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.images.validate(input, metadata) : match$1._0;
  let match$2 = fieldsStatuses.emailAddress;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.emailAddress.validate(input, metadata) : match$2._0;
  let match_0 = {
    TAG: "Ok",
    _0: input.lastName
  };
  let match$3 = fieldsStatuses.firstName;
  let tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.firstName.validate(input, metadata) : match$3._0;
  let match$4 = fieldsStatuses.description;
  let tmp$4;
  tmp$4 = typeof match$4 !== "object" ? validators.description.validate(input, metadata) : match$4._0;
  let match_0$1 = {
    TAG: "Ok",
    _0: input.privacy
  };
  let match_0$2 = {
    TAG: "Ok",
    _0: input.parkingDetails
  };
  let match_0$3 = {
    TAG: "Ok",
    _0: input.parkingSpaces
  };
  let match$5 = fieldsStatuses.numberOfUnits;
  let tmp$5;
  tmp$5 = typeof match$5 !== "object" ? validators.numberOfUnits.validate(input, metadata) : match$5._0;
  let match$6 = fieldsStatuses.lotSize;
  let tmp$6;
  tmp$6 = typeof match$6 !== "object" ? validators.lotSize.validate(input, metadata) : match$6._0;
  let match$7 = fieldsStatuses.livingArea;
  let tmp$7;
  tmp$7 = typeof match$7 !== "object" ? validators.livingArea.validate(input, metadata) : match$7._0;
  let match$8 = fieldsStatuses.halfBaths;
  let tmp$8;
  tmp$8 = typeof match$8 !== "object" ? validators.halfBaths.validate(input, metadata) : match$8._0;
  let match$9 = fieldsStatuses.baths;
  let tmp$9;
  tmp$9 = typeof match$9 !== "object" ? validators.baths.validate(input, metadata) : match$9._0;
  let match$10 = fieldsStatuses.beds;
  let tmp$10;
  tmp$10 = typeof match$10 !== "object" ? validators.beds.validate(input, metadata) : match$10._0;
  let match$11 = fieldsStatuses.propertyType;
  let tmp$11;
  tmp$11 = typeof match$11 !== "object" ? validators.propertyType.validate(input, metadata) : match$11._0;
  let match$12 = fieldsStatuses.maxPrice;
  let tmp$12;
  tmp$12 = typeof match$12 !== "object" ? validators.maxPrice.validate(input, metadata) : match$12._0;
  let match$13 = fieldsStatuses.minPrice;
  let tmp$13;
  tmp$13 = typeof match$13 !== "object" ? validators.minPrice.validate(input, metadata) : match$13._0;
  let match$14 = fieldsStatuses.price;
  let tmp$14;
  tmp$14 = typeof match$14 !== "object" ? validators.price.validate(input, metadata) : match$14._0;
  let match_0$4 = {
    TAG: "Ok",
    _0: input.priceType
  };
  let value = fieldsStatuses.location;
  let tmp$15;
  tmp$15 = typeof value !== "object" ? ({
      NAME: "Result",
      VAL: validators.location.validate(input, metadata)
    }) : (
      value.TAG === "Dirty" ? ({
          NAME: "Result",
          VAL: value._0
        }) : ({
          NAME: "Validating",
          VAL: value._0
        })
    );
  let match$15 = fieldsStatuses.area;
  let tmp$16;
  tmp$16 = typeof match$15 !== "object" ? validators.area.validate(input, metadata) : match$15._0;
  let match$16 = fieldsStatuses.address;
  let tmp$17;
  tmp$17 = typeof match$16 !== "object" ? validators.address.validate(input, metadata) : match$16._0;
  let filesResult = tmp;
  let exit = 0;
  let locationResult = tmp$15;
  if (typeof locationResult === "object") {
    if (locationResult.NAME === "Validating") {
      return {
        TAG: "Validating",
        fieldsStatuses: {
          files: {
            TAG: "Dirty",
            _0: filesResult,
            _1: "Shown"
          },
          images: {
            TAG: "Dirty",
            _0: tmp$1,
            _1: "Shown"
          },
          emailAddress: {
            TAG: "Dirty",
            _0: tmp$2,
            _1: "Shown"
          },
          lastName: {
            TAG: "Dirty",
            _0: match_0,
            _1: "Hidden"
          },
          firstName: {
            TAG: "Dirty",
            _0: tmp$3,
            _1: "Shown"
          },
          description: {
            TAG: "Dirty",
            _0: tmp$4,
            _1: "Shown"
          },
          privacy: {
            TAG: "Dirty",
            _0: match_0$1,
            _1: "Hidden"
          },
          parkingDetails: {
            TAG: "Dirty",
            _0: match_0$2,
            _1: "Hidden"
          },
          parkingSpaces: {
            TAG: "Dirty",
            _0: match_0$3,
            _1: "Hidden"
          },
          numberOfUnits: {
            TAG: "Dirty",
            _0: tmp$5,
            _1: "Shown"
          },
          lotSize: {
            TAG: "Dirty",
            _0: tmp$6,
            _1: "Shown"
          },
          livingArea: {
            TAG: "Dirty",
            _0: tmp$7,
            _1: "Shown"
          },
          halfBaths: {
            TAG: "Dirty",
            _0: tmp$8,
            _1: "Shown"
          },
          baths: {
            TAG: "Dirty",
            _0: tmp$9,
            _1: "Shown"
          },
          beds: {
            TAG: "Dirty",
            _0: tmp$10,
            _1: "Shown"
          },
          propertyType: {
            TAG: "Dirty",
            _0: tmp$11,
            _1: "Shown"
          },
          maxPrice: {
            TAG: "Dirty",
            _0: tmp$12,
            _1: "Shown"
          },
          minPrice: {
            TAG: "Dirty",
            _0: tmp$13,
            _1: "Shown"
          },
          price: {
            TAG: "Dirty",
            _0: tmp$14,
            _1: "Shown"
          },
          priceType: {
            TAG: "Dirty",
            _0: match_0$4,
            _1: "Hidden"
          },
          location: locationResult.NAME === "Result" ? ({
              TAG: "Dirty",
              _0: locationResult.VAL,
              _1: "Shown"
            }) : ({
              TAG: "Validating",
              _0: locationResult.VAL
            }),
          area: {
            TAG: "Dirty",
            _0: tmp$16,
            _1: "Shown"
          },
          address: {
            TAG: "Dirty",
            _0: tmp$17,
            _1: "Shown"
          }
        },
        collectionsStatuses: undefined
      };
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2 && filesResult.TAG === "Ok") {
    let imagesResult = tmp$1;
    if (imagesResult.TAG === "Ok") {
      let emailAddressResult = tmp$2;
      if (emailAddressResult.TAG === "Ok") {
        let lastNameResult = match_0;
        if (lastNameResult.TAG === "Ok") {
          let firstNameResult = tmp$3;
          if (firstNameResult.TAG === "Ok") {
            let descriptionResult = tmp$4;
            if (descriptionResult.TAG === "Ok") {
              let privacyResult = match_0$1;
              if (privacyResult.TAG === "Ok") {
                let parkingDetailsResult = match_0$2;
                if (parkingDetailsResult.TAG === "Ok") {
                  let parkingSpacesResult = match_0$3;
                  if (parkingSpacesResult.TAG === "Ok") {
                    let numberOfUnitsResult = tmp$5;
                    if (numberOfUnitsResult.TAG === "Ok") {
                      let lotSizeResult = tmp$6;
                      if (lotSizeResult.TAG === "Ok") {
                        let livingAreaResult = tmp$7;
                        if (livingAreaResult.TAG === "Ok") {
                          let halfBathsResult = tmp$8;
                          if (halfBathsResult.TAG === "Ok") {
                            let bathsResult = tmp$9;
                            if (bathsResult.TAG === "Ok") {
                              let bedsResult = tmp$10;
                              if (bedsResult.TAG === "Ok") {
                                let propertyTypeResult = tmp$11;
                                if (propertyTypeResult.TAG === "Ok") {
                                  let maxPriceResult = tmp$12;
                                  if (maxPriceResult.TAG === "Ok") {
                                    let minPriceResult = tmp$13;
                                    if (minPriceResult.TAG === "Ok") {
                                      let priceResult = tmp$14;
                                      if (priceResult.TAG === "Ok") {
                                        let priceTypeResult = match_0$4;
                                        if (priceTypeResult.TAG === "Ok") {
                                          let match$17 = tmp$15;
                                          if (typeof match$17 === "object" && match$17.NAME === "Result") {
                                            let locationResult$1 = match$17.VAL;
                                            if (locationResult$1.TAG === "Ok") {
                                              let addressResult = tmp$17;
                                              let areaResult = tmp$16;
                                              return {
                                                TAG: "Valid",
                                                output: {
                                                  address: addressResult._0,
                                                  area: areaResult._0,
                                                  location: locationResult$1._0,
                                                  priceType: priceTypeResult._0,
                                                  price: priceResult._0,
                                                  minPrice: minPriceResult._0,
                                                  maxPrice: maxPriceResult._0,
                                                  propertyType: propertyTypeResult._0,
                                                  beds: bedsResult._0,
                                                  baths: bathsResult._0,
                                                  halfBaths: halfBathsResult._0,
                                                  livingArea: livingAreaResult._0,
                                                  numberOfUnits: numberOfUnitsResult._0,
                                                  lotSize: lotSizeResult._0,
                                                  parkingSpaces: parkingSpacesResult._0,
                                                  parkingDetails: parkingDetailsResult._0,
                                                  privacy: privacyResult._0,
                                                  description: descriptionResult._0,
                                                  firstName: firstNameResult._0,
                                                  lastName: lastNameResult._0,
                                                  emailAddress: emailAddressResult._0,
                                                  images: imagesResult._0,
                                                  files: filesResult._0
                                                },
                                                fieldsStatuses: {
                                                  files: {
                                                    TAG: "Dirty",
                                                    _0: filesResult,
                                                    _1: "Shown"
                                                  },
                                                  images: {
                                                    TAG: "Dirty",
                                                    _0: imagesResult,
                                                    _1: "Shown"
                                                  },
                                                  emailAddress: {
                                                    TAG: "Dirty",
                                                    _0: emailAddressResult,
                                                    _1: "Shown"
                                                  },
                                                  lastName: {
                                                    TAG: "Dirty",
                                                    _0: lastNameResult,
                                                    _1: "Hidden"
                                                  },
                                                  firstName: {
                                                    TAG: "Dirty",
                                                    _0: firstNameResult,
                                                    _1: "Shown"
                                                  },
                                                  description: {
                                                    TAG: "Dirty",
                                                    _0: descriptionResult,
                                                    _1: "Shown"
                                                  },
                                                  privacy: {
                                                    TAG: "Dirty",
                                                    _0: privacyResult,
                                                    _1: "Hidden"
                                                  },
                                                  parkingDetails: {
                                                    TAG: "Dirty",
                                                    _0: parkingDetailsResult,
                                                    _1: "Hidden"
                                                  },
                                                  parkingSpaces: {
                                                    TAG: "Dirty",
                                                    _0: parkingSpacesResult,
                                                    _1: "Hidden"
                                                  },
                                                  numberOfUnits: {
                                                    TAG: "Dirty",
                                                    _0: numberOfUnitsResult,
                                                    _1: "Shown"
                                                  },
                                                  lotSize: {
                                                    TAG: "Dirty",
                                                    _0: lotSizeResult,
                                                    _1: "Shown"
                                                  },
                                                  livingArea: {
                                                    TAG: "Dirty",
                                                    _0: livingAreaResult,
                                                    _1: "Shown"
                                                  },
                                                  halfBaths: {
                                                    TAG: "Dirty",
                                                    _0: halfBathsResult,
                                                    _1: "Shown"
                                                  },
                                                  baths: {
                                                    TAG: "Dirty",
                                                    _0: bathsResult,
                                                    _1: "Shown"
                                                  },
                                                  beds: {
                                                    TAG: "Dirty",
                                                    _0: bedsResult,
                                                    _1: "Shown"
                                                  },
                                                  propertyType: {
                                                    TAG: "Dirty",
                                                    _0: propertyTypeResult,
                                                    _1: "Shown"
                                                  },
                                                  maxPrice: {
                                                    TAG: "Dirty",
                                                    _0: maxPriceResult,
                                                    _1: "Shown"
                                                  },
                                                  minPrice: {
                                                    TAG: "Dirty",
                                                    _0: minPriceResult,
                                                    _1: "Shown"
                                                  },
                                                  price: {
                                                    TAG: "Dirty",
                                                    _0: priceResult,
                                                    _1: "Shown"
                                                  },
                                                  priceType: {
                                                    TAG: "Dirty",
                                                    _0: priceTypeResult,
                                                    _1: "Hidden"
                                                  },
                                                  location: {
                                                    TAG: "Dirty",
                                                    _0: locationResult$1,
                                                    _1: "Shown"
                                                  },
                                                  area: {
                                                    TAG: "Dirty",
                                                    _0: areaResult,
                                                    _1: "Shown"
                                                  },
                                                  address: {
                                                    TAG: "Dirty",
                                                    _0: addressResult,
                                                    _1: "Shown"
                                                  }
                                                },
                                                collectionsStatuses: undefined
                                              };
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      files: {
        TAG: "Dirty",
        _0: filesResult,
        _1: "Shown"
      },
      images: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      emailAddress: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      },
      lastName: {
        TAG: "Dirty",
        _0: match_0,
        _1: "Hidden"
      },
      firstName: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      },
      description: {
        TAG: "Dirty",
        _0: tmp$4,
        _1: "Shown"
      },
      privacy: {
        TAG: "Dirty",
        _0: match_0$1,
        _1: "Hidden"
      },
      parkingDetails: {
        TAG: "Dirty",
        _0: match_0$2,
        _1: "Hidden"
      },
      parkingSpaces: {
        TAG: "Dirty",
        _0: match_0$3,
        _1: "Hidden"
      },
      numberOfUnits: {
        TAG: "Dirty",
        _0: tmp$5,
        _1: "Shown"
      },
      lotSize: {
        TAG: "Dirty",
        _0: tmp$6,
        _1: "Shown"
      },
      livingArea: {
        TAG: "Dirty",
        _0: tmp$7,
        _1: "Shown"
      },
      halfBaths: {
        TAG: "Dirty",
        _0: tmp$8,
        _1: "Shown"
      },
      baths: {
        TAG: "Dirty",
        _0: tmp$9,
        _1: "Shown"
      },
      beds: {
        TAG: "Dirty",
        _0: tmp$10,
        _1: "Shown"
      },
      propertyType: {
        TAG: "Dirty",
        _0: tmp$11,
        _1: "Shown"
      },
      maxPrice: {
        TAG: "Dirty",
        _0: tmp$12,
        _1: "Shown"
      },
      minPrice: {
        TAG: "Dirty",
        _0: tmp$13,
        _1: "Shown"
      },
      price: {
        TAG: "Dirty",
        _0: tmp$14,
        _1: "Shown"
      },
      priceType: {
        TAG: "Dirty",
        _0: match_0$4,
        _1: "Hidden"
      },
      location: {
        TAG: "Dirty",
        _0: tmp$15.VAL,
        _1: "Shown"
      },
      area: {
        TAG: "Dirty",
        _0: tmp$16,
        _1: "Shown"
      },
      address: {
        TAG: "Dirty",
        _0: tmp$17,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, metadata, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurFilesField" :
          let result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.files, validators_files, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.files = status;
            return newrecord;
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurImagesField" :
          let result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.images, validators_images, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.images = status;
            return newrecord;
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurEmailAddressField" :
          let result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.emailAddress, validators_emailAddress, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.emailAddress = status;
            return newrecord;
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLastNameField" :
          let result$3 = Formality.validateFieldOnBlurWithoutValidator(state.input.lastName, state.fieldsStatuses.lastName, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.lastName = status;
            return newrecord;
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFirstNameField" :
          let result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.firstName, validators_firstName, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.firstName = status;
            return newrecord;
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurDescriptionField" :
          let result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.description, validators_description, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.description = status;
            return newrecord;
          });
          if (result$5 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$5,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurPrivacyField" :
          let result$6 = Formality.validateFieldOnBlurWithoutValidator(state.input.privacy, state.fieldsStatuses.privacy, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.privacy = status;
            return newrecord;
          });
          if (result$6 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$6,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurParkingDetailsField" :
          let result$7 = Formality.validateFieldOnBlurWithoutValidator(state.input.parkingDetails, state.fieldsStatuses.parkingDetails, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.parkingDetails = status;
            return newrecord;
          });
          if (result$7 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$7,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurParkingSpacesField" :
          let result$8 = Formality.validateFieldOnBlurWithoutValidator(state.input.parkingSpaces, state.fieldsStatuses.parkingSpaces, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.parkingSpaces = status;
            return newrecord;
          });
          if (result$8 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$8,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurNumberOfUnitsField" :
          let result$9 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.numberOfUnits, validators_numberOfUnits, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.numberOfUnits = status;
            return newrecord;
          });
          if (result$9 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$9,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLotSizeField" :
          let result$10 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.lotSize, validators_lotSize, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.lotSize = status;
            return newrecord;
          });
          if (result$10 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$10,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLivingAreaField" :
          let result$11 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.livingArea, validators_livingArea, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.livingArea = status;
            return newrecord;
          });
          if (result$11 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$11,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurHalfBathsField" :
          let result$12 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.halfBaths, validators_halfBaths, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.halfBaths = status;
            return newrecord;
          });
          if (result$12 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$12,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurBathsField" :
          let result$13 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.baths, validators_baths, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.baths = status;
            return newrecord;
          });
          if (result$13 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$13,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurBedsField" :
          let result$14 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.beds, validators_beds, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.beds = status;
            return newrecord;
          });
          if (result$14 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$14,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurPropertyTypeField" :
          let result$15 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.propertyType, validators_propertyType, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$15 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$15,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurMaxPriceField" :
          let result$16 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.maxPrice, validators_maxPrice, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.maxPrice = status;
            return newrecord;
          });
          if (result$16 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$16,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurMinPriceField" :
          let result$17 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.minPrice, validators_minPrice, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.minPrice = status;
            return newrecord;
          });
          if (result$17 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$17,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurPriceField" :
          let result$18 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.price, validators_price, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.price = status;
            return newrecord;
          });
          if (result$18 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$18,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurPriceTypeField" :
          let result$19 = Formality.validateFieldOnBlurWithoutValidator(state.input.priceType, state.fieldsStatuses.priceType, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.priceType = status;
            return newrecord;
          });
          if (result$19 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$19,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLocationField" :
          let result$20 = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.location, validators_location, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.location = status;
            return newrecord;
          });
          if (result$20 === undefined) {
            return "NoUpdate";
          }
          let value = result$20.location;
          if (typeof value === "object" && value.TAG !== "Dirty") {
            let value$1 = value._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: state.input,
                fieldsStatuses: result$20,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators_location.validateAsync([
                value$1,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: result$20,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
          break;
        case "BlurAreaField" :
          let result$21 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.area, validators_area, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.area = status;
            return newrecord;
          });
          if (result$21 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$21,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurAddressField" :
          let result$22 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.address, validators_address, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.address = status;
            return newrecord;
          });
          if (result$22 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$22,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let apply_validate = validateForm;
          let match$1 = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
          switch (match$1.TAG) {
            case "Valid" :
              let output = match$1.output;
              let error = state.formStatus;
              let tmp;
              tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
              return {
                TAG: "UpdateWithSideEffects",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: {
                    TAG: "Submitting",
                    _0: tmp
                  },
                  submissionStatus: "AttemptedToSubmit"
                },
                _1: param => {
                  let dispatch = param.dispatch;
                  onSubmit(output, {
                    notifyOnSuccess: input => dispatch({
                      TAG: "SetSubmittedStatus",
                      _0: input
                    }),
                    notifyOnFailure: error => dispatch({
                      TAG: "SetSubmissionFailedStatus",
                      _0: error
                    }),
                    reset: () => dispatch("Reset"),
                    dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
                  });
                }
              };
            case "Invalid" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: "Editing",
                  submissionStatus: "AttemptedToSubmit"
                }
              };
            case "Validating" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: state.formStatus,
                  submissionStatus: state.submissionStatus
                }
              };
          }
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateFilesField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.files, state.submissionStatus, validators_files, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.files = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateImagesField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.images, state.submissionStatus, validators_images, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.images = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateEmailAddressField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.emailAddress, state.submissionStatus, validators_emailAddress, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.emailAddress = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLastNameField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$3.lastName, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.lastName = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFirstNameField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.firstName = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateDescriptionField" :
          let nextInput$5 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$5,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.description, state.submissionStatus, validators_description, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.description = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdatePrivacyField" :
          let nextInput$6 = action._0(state.input);
          let nextFieldsStatuses = {
            contents: state.fieldsStatuses
          };
          let result$23 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$6, metadata, nextFieldsStatuses.contents.description, validators_description, status => {
            let newrecord = {...nextFieldsStatuses.contents};
            newrecord.description = status;
            return newrecord;
          });
          if (result$23 !== undefined) {
            nextFieldsStatuses.contents = result$23;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$6,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$6.privacy, status => {
                let newrecord = {...nextFieldsStatuses.contents};
                newrecord.privacy = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateParkingDetailsField" :
          let nextInput$7 = action._0(state.input);
          let nextFieldsStatuses$1 = {
            contents: state.fieldsStatuses
          };
          let result$24 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$7, metadata, nextFieldsStatuses$1.contents.propertyType, validators_propertyType, status => {
            let newrecord = {...nextFieldsStatuses$1.contents};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$24 !== undefined) {
            nextFieldsStatuses$1.contents = result$24;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$7,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$7.parkingDetails, status => {
                let newrecord = {...nextFieldsStatuses$1.contents};
                newrecord.parkingDetails = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateParkingSpacesField" :
          let nextInput$8 = action._0(state.input);
          let nextFieldsStatuses$2 = {
            contents: state.fieldsStatuses
          };
          let result$25 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$8, metadata, nextFieldsStatuses$2.contents.propertyType, validators_propertyType, status => {
            let newrecord = {...nextFieldsStatuses$2.contents};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$25 !== undefined) {
            nextFieldsStatuses$2.contents = result$25;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$8,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$8.parkingSpaces, status => {
                let newrecord = {...nextFieldsStatuses$2.contents};
                newrecord.parkingSpaces = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateNumberOfUnitsField" :
          let nextInput$9 = action._0(state.input);
          let nextFieldsStatuses$3 = {
            contents: state.fieldsStatuses
          };
          let result$26 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$9, metadata, nextFieldsStatuses$3.contents.propertyType, validators_propertyType, status => {
            let newrecord = {...nextFieldsStatuses$3.contents};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$26 !== undefined) {
            nextFieldsStatuses$3.contents = result$26;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$9,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$9, metadata, nextFieldsStatuses$3.contents.numberOfUnits, state.submissionStatus, validators_numberOfUnits, status => {
                let newrecord = {...nextFieldsStatuses$3.contents};
                newrecord.numberOfUnits = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLotSizeField" :
          let nextInput$10 = action._0(state.input);
          let nextFieldsStatuses$4 = {
            contents: state.fieldsStatuses
          };
          let result$27 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$10, metadata, nextFieldsStatuses$4.contents.propertyType, validators_propertyType, status => {
            let newrecord = {...nextFieldsStatuses$4.contents};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$27 !== undefined) {
            nextFieldsStatuses$4.contents = result$27;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$10,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$10, metadata, nextFieldsStatuses$4.contents.lotSize, state.submissionStatus, validators_lotSize, status => {
                let newrecord = {...nextFieldsStatuses$4.contents};
                newrecord.lotSize = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLivingAreaField" :
          let nextInput$11 = action._0(state.input);
          let nextFieldsStatuses$5 = {
            contents: state.fieldsStatuses
          };
          let result$28 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$11, metadata, nextFieldsStatuses$5.contents.propertyType, validators_propertyType, status => {
            let newrecord = {...nextFieldsStatuses$5.contents};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$28 !== undefined) {
            nextFieldsStatuses$5.contents = result$28;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$11,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$11, metadata, nextFieldsStatuses$5.contents.livingArea, state.submissionStatus, validators_livingArea, status => {
                let newrecord = {...nextFieldsStatuses$5.contents};
                newrecord.livingArea = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateHalfBathsField" :
          let nextInput$12 = action._0(state.input);
          let nextFieldsStatuses$6 = {
            contents: state.fieldsStatuses
          };
          let result$29 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$12, metadata, nextFieldsStatuses$6.contents.propertyType, validators_propertyType, status => {
            let newrecord = {...nextFieldsStatuses$6.contents};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$29 !== undefined) {
            nextFieldsStatuses$6.contents = result$29;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$12,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$12, metadata, nextFieldsStatuses$6.contents.halfBaths, state.submissionStatus, validators_halfBaths, status => {
                let newrecord = {...nextFieldsStatuses$6.contents};
                newrecord.halfBaths = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateBathsField" :
          let nextInput$13 = action._0(state.input);
          let nextFieldsStatuses$7 = {
            contents: state.fieldsStatuses
          };
          let result$30 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$13, metadata, nextFieldsStatuses$7.contents.propertyType, validators_propertyType, status => {
            let newrecord = {...nextFieldsStatuses$7.contents};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$30 !== undefined) {
            nextFieldsStatuses$7.contents = result$30;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$13,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$13, metadata, nextFieldsStatuses$7.contents.baths, state.submissionStatus, validators_baths, status => {
                let newrecord = {...nextFieldsStatuses$7.contents};
                newrecord.baths = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateBedsField" :
          let nextInput$14 = action._0(state.input);
          let nextFieldsStatuses$8 = {
            contents: state.fieldsStatuses
          };
          let result$31 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$14, metadata, nextFieldsStatuses$8.contents.propertyType, validators_propertyType, status => {
            let newrecord = {...nextFieldsStatuses$8.contents};
            newrecord.propertyType = status;
            return newrecord;
          });
          if (result$31 !== undefined) {
            nextFieldsStatuses$8.contents = result$31;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$14,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$14, metadata, nextFieldsStatuses$8.contents.beds, state.submissionStatus, validators_beds, status => {
                let newrecord = {...nextFieldsStatuses$8.contents};
                newrecord.beds = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdatePropertyTypeField" :
          let nextInput$15 = action._0(state.input);
          let nextFieldsStatuses$9 = {
            contents: state.fieldsStatuses
          };
          let result$32 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$15, metadata, nextFieldsStatuses$9.contents.beds, validators_beds, status => {
            let newrecord = {...nextFieldsStatuses$9.contents};
            newrecord.beds = status;
            return newrecord;
          });
          if (result$32 !== undefined) {
            nextFieldsStatuses$9.contents = result$32;
          }
          let result$33 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$15, metadata, nextFieldsStatuses$9.contents.baths, validators_baths, status => {
            let newrecord = {...nextFieldsStatuses$9.contents};
            newrecord.baths = status;
            return newrecord;
          });
          if (result$33 !== undefined) {
            nextFieldsStatuses$9.contents = result$33;
          }
          let result$34 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$15, metadata, nextFieldsStatuses$9.contents.halfBaths, validators_halfBaths, status => {
            let newrecord = {...nextFieldsStatuses$9.contents};
            newrecord.halfBaths = status;
            return newrecord;
          });
          if (result$34 !== undefined) {
            nextFieldsStatuses$9.contents = result$34;
          }
          let result$35 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$15, metadata, nextFieldsStatuses$9.contents.livingArea, validators_livingArea, status => {
            let newrecord = {...nextFieldsStatuses$9.contents};
            newrecord.livingArea = status;
            return newrecord;
          });
          if (result$35 !== undefined) {
            nextFieldsStatuses$9.contents = result$35;
          }
          let result$36 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$15, metadata, nextFieldsStatuses$9.contents.lotSize, validators_lotSize, status => {
            let newrecord = {...nextFieldsStatuses$9.contents};
            newrecord.lotSize = status;
            return newrecord;
          });
          if (result$36 !== undefined) {
            nextFieldsStatuses$9.contents = result$36;
          }
          let result$37 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$15, metadata, nextFieldsStatuses$9.contents.numberOfUnits, validators_numberOfUnits, status => {
            let newrecord = {...nextFieldsStatuses$9.contents};
            newrecord.numberOfUnits = status;
            return newrecord;
          });
          if (result$37 !== undefined) {
            nextFieldsStatuses$9.contents = result$37;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$15,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$15, metadata, nextFieldsStatuses$9.contents.propertyType, state.submissionStatus, validators_propertyType, status => {
                let newrecord = {...nextFieldsStatuses$9.contents};
                newrecord.propertyType = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateMaxPriceField" :
          let nextInput$16 = action._0(state.input);
          let nextFieldsStatuses$10 = {
            contents: state.fieldsStatuses
          };
          let result$38 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$16, metadata, nextFieldsStatuses$10.contents.minPrice, validators_minPrice, status => {
            let newrecord = {...nextFieldsStatuses$10.contents};
            newrecord.minPrice = status;
            return newrecord;
          });
          if (result$38 !== undefined) {
            nextFieldsStatuses$10.contents = result$38;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$16,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$16, metadata, nextFieldsStatuses$10.contents.maxPrice, state.submissionStatus, validators_maxPrice, status => {
                let newrecord = {...nextFieldsStatuses$10.contents};
                newrecord.maxPrice = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateMinPriceField" :
          let nextInput$17 = action._0(state.input);
          let nextFieldsStatuses$11 = {
            contents: state.fieldsStatuses
          };
          let result$39 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$17, metadata, nextFieldsStatuses$11.contents.maxPrice, validators_maxPrice, status => {
            let newrecord = {...nextFieldsStatuses$11.contents};
            newrecord.maxPrice = status;
            return newrecord;
          });
          if (result$39 !== undefined) {
            nextFieldsStatuses$11.contents = result$39;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$17,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$17, metadata, nextFieldsStatuses$11.contents.minPrice, state.submissionStatus, validators_minPrice, status => {
                let newrecord = {...nextFieldsStatuses$11.contents};
                newrecord.minPrice = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdatePriceField" :
          let nextInput$18 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$18,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$18, metadata, state.fieldsStatuses.price, state.submissionStatus, validators_price, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.price = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdatePriceTypeField" :
          let nextInput$19 = action._0(state.input);
          let nextFieldsStatuses$12 = {
            contents: state.fieldsStatuses
          };
          let result$40 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$19, metadata, nextFieldsStatuses$12.contents.price, validators_price, status => {
            let newrecord = {...nextFieldsStatuses$12.contents};
            newrecord.price = status;
            return newrecord;
          });
          if (result$40 !== undefined) {
            nextFieldsStatuses$12.contents = result$40;
          }
          let result$41 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$19, metadata, nextFieldsStatuses$12.contents.minPrice, validators_minPrice, status => {
            let newrecord = {...nextFieldsStatuses$12.contents};
            newrecord.minPrice = status;
            return newrecord;
          });
          if (result$41 !== undefined) {
            nextFieldsStatuses$12.contents = result$41;
          }
          let result$42 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$19, metadata, nextFieldsStatuses$12.contents.maxPrice, validators_maxPrice, status => {
            let newrecord = {...nextFieldsStatuses$12.contents};
            newrecord.maxPrice = status;
            return newrecord;
          });
          if (result$42 !== undefined) {
            nextFieldsStatuses$12.contents = result$42;
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$19,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$19.priceType, status => {
                let newrecord = {...nextFieldsStatuses$12.contents};
                newrecord.priceType = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLocationField" :
          let nextInput$20 = action._0(state.input);
          let nextFieldsStatuses$13 = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput$20, metadata, state.fieldsStatuses.location, state.submissionStatus, validators_location, status => {
            let newrecord = {...state.fieldsStatuses};
            newrecord.location = status;
            return newrecord;
          });
          let value$2 = nextFieldsStatuses$13.location;
          if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
            let value$3 = value$2._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: nextInput$20,
                fieldsStatuses: nextFieldsStatuses$13,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators_location.validateAsync([
                value$3,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$20,
              fieldsStatuses: nextFieldsStatuses$13,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateAreaField" :
          let nextInput$21 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$21,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$21, metadata, state.fieldsStatuses.area, state.submissionStatus, validators_area, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.area = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateAddressField" :
          let nextInput$22 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$22,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$22, metadata, state.fieldsStatuses.address, state.submissionStatus, validators_address, status => {
                let newrecord = {...state.fieldsStatuses};
                newrecord.address = status;
                return newrecord;
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "ApplyAsyncResultForLocationField" :
          let validator = validators_location;
          let x = state.fieldsStatuses.location;
          if (typeof x !== "object") {
            return "NoUpdate";
          }
          if (x.TAG === "Dirty") {
            return "NoUpdate";
          }
          if (!validator.eq(x._0, action._0)) {
            return "NoUpdate";
          }
          let newrecord = {...state.fieldsStatuses};
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: (newrecord.location = {
                TAG: "Dirty",
                _0: action._1,
                _1: "Shown"
              }, newrecord),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateFiles: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFilesField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateImages: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateImagesField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateEmailAddress: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateEmailAddressField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLastName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLastNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFirstName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFirstNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateDescription: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateDescriptionField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updatePrivacy: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdatePrivacyField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateParkingDetails: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateParkingDetailsField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateParkingSpaces: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateParkingSpacesField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateNumberOfUnits: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateNumberOfUnitsField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLotSize: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLotSizeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLivingArea: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLivingAreaField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateHalfBaths: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateHalfBathsField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateBaths: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBathsField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateBeds: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBedsField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updatePropertyType: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdatePropertyTypeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateMaxPrice: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMaxPriceField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateMinPrice: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMinPriceField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updatePrice: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdatePriceField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updatePriceType: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdatePriceTypeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLocation: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLocationField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateArea: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateAreaField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateAddress: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateAddressField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurFiles: () => dispatch("BlurFilesField"),
    blurImages: () => dispatch("BlurImagesField"),
    blurEmailAddress: () => dispatch("BlurEmailAddressField"),
    blurLastName: () => dispatch("BlurLastNameField"),
    blurFirstName: () => dispatch("BlurFirstNameField"),
    blurDescription: () => dispatch("BlurDescriptionField"),
    blurPrivacy: () => dispatch("BlurPrivacyField"),
    blurParkingDetails: () => dispatch("BlurParkingDetailsField"),
    blurParkingSpaces: () => dispatch("BlurParkingSpacesField"),
    blurNumberOfUnits: () => dispatch("BlurNumberOfUnitsField"),
    blurLotSize: () => dispatch("BlurLotSizeField"),
    blurLivingArea: () => dispatch("BlurLivingAreaField"),
    blurHalfBaths: () => dispatch("BlurHalfBathsField"),
    blurBaths: () => dispatch("BlurBathsField"),
    blurBeds: () => dispatch("BlurBedsField"),
    blurPropertyType: () => dispatch("BlurPropertyTypeField"),
    blurMaxPrice: () => dispatch("BlurMaxPriceField"),
    blurMinPrice: () => dispatch("BlurMinPriceField"),
    blurPrice: () => dispatch("BlurPriceField"),
    blurPriceType: () => dispatch("BlurPriceTypeField"),
    blurLocation: () => dispatch("BlurLocationField"),
    blurArea: () => dispatch("BlurAreaField"),
    blurAddress: () => dispatch("BlurAddressField"),
    filesResult: Formality.exposeFieldResult(state.fieldsStatuses.files),
    imagesResult: Formality.exposeFieldResult(state.fieldsStatuses.images),
    emailAddressResult: Formality.exposeFieldResult(state.fieldsStatuses.emailAddress),
    lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
    firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
    descriptionResult: Formality.exposeFieldResult(state.fieldsStatuses.description),
    privacyResult: Formality.exposeFieldResult(state.fieldsStatuses.privacy),
    parkingDetailsResult: Formality.exposeFieldResult(state.fieldsStatuses.parkingDetails),
    parkingSpacesResult: Formality.exposeFieldResult(state.fieldsStatuses.parkingSpaces),
    numberOfUnitsResult: Formality.exposeFieldResult(state.fieldsStatuses.numberOfUnits),
    lotSizeResult: Formality.exposeFieldResult(state.fieldsStatuses.lotSize),
    livingAreaResult: Formality.exposeFieldResult(state.fieldsStatuses.livingArea),
    halfBathsResult: Formality.exposeFieldResult(state.fieldsStatuses.halfBaths),
    bathsResult: Formality.exposeFieldResult(state.fieldsStatuses.baths),
    bedsResult: Formality.exposeFieldResult(state.fieldsStatuses.beds),
    propertyTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.propertyType),
    maxPriceResult: Formality.exposeFieldResult(state.fieldsStatuses.maxPrice),
    minPriceResult: Formality.exposeFieldResult(state.fieldsStatuses.minPrice),
    priceResult: Formality.exposeFieldResult(state.fieldsStatuses.price),
    priceTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.priceType),
    locationResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.location),
    areaResult: Formality.exposeFieldResult(state.fieldsStatuses.area),
    addressResult: Formality.exposeFieldResult(state.fieldsStatuses.address),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let exit = 0;
      let tmp = match.files;
      if (typeof tmp !== "object") {
        let tmp$1 = match.images;
        if (typeof tmp$1 !== "object") {
          let tmp$2 = match.emailAddress;
          if (typeof tmp$2 !== "object") {
            let tmp$3 = match.lastName;
            if (typeof tmp$3 !== "object") {
              let tmp$4 = match.firstName;
              if (typeof tmp$4 !== "object") {
                let tmp$5 = match.description;
                if (typeof tmp$5 !== "object") {
                  let tmp$6 = match.privacy;
                  if (typeof tmp$6 !== "object") {
                    let tmp$7 = match.parkingDetails;
                    if (typeof tmp$7 !== "object") {
                      let tmp$8 = match.parkingSpaces;
                      if (typeof tmp$8 !== "object") {
                        let tmp$9 = match.numberOfUnits;
                        if (typeof tmp$9 !== "object") {
                          let tmp$10 = match.lotSize;
                          if (typeof tmp$10 !== "object") {
                            let tmp$11 = match.livingArea;
                            if (typeof tmp$11 !== "object") {
                              let tmp$12 = match.halfBaths;
                              if (typeof tmp$12 !== "object") {
                                let tmp$13 = match.baths;
                                if (typeof tmp$13 !== "object") {
                                  let tmp$14 = match.beds;
                                  if (typeof tmp$14 !== "object") {
                                    let tmp$15 = match.propertyType;
                                    if (typeof tmp$15 !== "object") {
                                      let tmp$16 = match.maxPrice;
                                      if (typeof tmp$16 !== "object") {
                                        let tmp$17 = match.minPrice;
                                        if (typeof tmp$17 !== "object") {
                                          let tmp$18 = match.price;
                                          if (typeof tmp$18 !== "object") {
                                            let tmp$19 = match.priceType;
                                            if (typeof tmp$19 !== "object") {
                                              let tmp$20 = match.location;
                                              if (typeof tmp$20 !== "object") {
                                                let tmp$21 = match.area;
                                                if (typeof tmp$21 !== "object") {
                                                  let tmp$22 = match.address;
                                                  if (typeof tmp$22 !== "object") {
                                                    return false;
                                                  }
                                                  exit = 1;
                                                } else {
                                                  exit = 1;
                                                }
                                              } else {
                                                exit = 1;
                                              }
                                            } else {
                                              exit = 1;
                                            }
                                          } else {
                                            exit = 1;
                                          }
                                        } else {
                                          exit = 1;
                                        }
                                      } else {
                                        exit = 1;
                                      }
                                    } else {
                                      exit = 1;
                                    }
                                  } else {
                                    exit = 1;
                                  }
                                } else {
                                  exit = 1;
                                }
                              } else {
                                exit = 1;
                              }
                            } else {
                              exit = 1;
                            }
                          } else {
                            exit = 1;
                          }
                        } else {
                          exit = 1;
                        }
                      } else {
                        exit = 1;
                      }
                    } else {
                      exit = 1;
                    }
                  } else {
                    exit = 1;
                  }
                } else {
                  exit = 1;
                }
              } else {
                exit = 1;
              }
            } else {
              exit = 1;
            }
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        let exit$1 = 0;
        exit$1 = 2;
        if (exit$1 === 2) {
          let exit$2 = 0;
          exit$2 = 3;
          if (exit$2 === 3) {
            let exit$3 = 0;
            exit$3 = 4;
            if (exit$3 === 4) {
              let exit$4 = 0;
              exit$4 = 5;
              if (exit$4 === 5) {
                let exit$5 = 0;
                exit$5 = 6;
                if (exit$5 === 6) {
                  let exit$6 = 0;
                  exit$6 = 7;
                  if (exit$6 === 7) {
                    let exit$7 = 0;
                    exit$7 = 8;
                    if (exit$7 === 8) {
                      let exit$8 = 0;
                      exit$8 = 9;
                      if (exit$8 === 9) {
                        let exit$9 = 0;
                        exit$9 = 10;
                        if (exit$9 === 10) {
                          let exit$10 = 0;
                          exit$10 = 11;
                          if (exit$10 === 11) {
                            let exit$11 = 0;
                            exit$11 = 12;
                            if (exit$11 === 12) {
                              let exit$12 = 0;
                              exit$12 = 13;
                              if (exit$12 === 13) {
                                return true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    valid: () => {
      let apply_validate = validateForm;
      let match = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
      switch (match.TAG) {
        case "Valid" :
          return true;
        case "Invalid" :
          return false;
        case "Validating" :
          return;
      }
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let QuietSellerPrivacy;

let PropertyLocation;

let ForSalePropertyPrice;

let ForSalePropertyAttributes;

let ClientEmailAddress;

let debounceInterval = 700;

let initialCollectionsStatuses;

exports.QuietSellerPrivacy = QuietSellerPrivacy;
exports.PropertyLocation = PropertyLocation;
exports.ForSalePropertyPrice = ForSalePropertyPrice;
exports.ForSalePropertyAttributes = ForSalePropertyAttributes;
exports.ClientEmailAddress = ClientEmailAddress;
exports.Config = Config;
exports.debounceInterval = debounceInterval;
exports.validators = validators;
exports.initialFieldsStatuses = initialFieldsStatuses;
exports.initialFieldStatuses_xxx = initialFieldStatuses_xxx;
exports.initialCollectionsStatuses = initialCollectionsStatuses;
exports.initialState = initialState;
exports.validateForm = validateForm;
exports.useForm = useForm;
/* validators Not a pure module */
